export const textLimit = (text, length = 50) => {

  if (text.length > length) {
    let str = text.slice(0, length);
    const a = str.split(" ");
    a.splice(a.length-1,1);
    return `${a.join(" ")} ...`;
  }
  return text;
};
